module.exports = __webpack_public_path__ + "static/assets/cb1969191224b12f0a2cb7cfe4990b24.svg";